import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import api from '../../services/api';

const typeLabels = {
  expiry_alert: 'Срок годности',
  task_assigned: 'Задача',
  osg_alert: 'ОСГ',
  display_alert: 'Выкладка',
};
const typeVariant = {
  expiry_alert: 'warning',
  task_assigned: 'primary',
  osg_alert: 'osg',
  display_alert: 'display',
};

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/notifications?page=1&per_page=100');
        if (res?.data) setNotifications(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  const handleMarkAllRead = async () => {
    try {
      await api.patch('/v1/notifications/read-all');
      setNotifications(n => n.map(x => ({ ...x, is_read: true })));
    } catch (e) { console.error(e); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 38, height: 38, borderRadius: 10, background: '#E6FAFB',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Bell size={20} color="#009995" />
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Уведомления</h1>
        </div>
        {notifications.some(n => !n.is_read) && (
          <Button variant="secondary" size="sm" onClick={handleMarkAllRead}>Прочитать все</Button>
        )}
      </div>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
          <span style={{ color: '#94A3B8', fontSize: 13 }}>Загрузка...</span>
        </div>
      ) : notifications.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {notifications.map(n => (
            <Card key={n.id} style={{
              background: n.is_read ? '#fff' : '#F8FCFE',
              borderLeft: n.is_read ? undefined : '3px solid #00CEEE',
              transition: 'all 0.15s',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                    <Badge variant={typeVariant[n.type] || 'gray'}>{typeLabels[n.type] || n.type || '\u2014'}</Badge>
                    {!n.is_read && <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#00CEEE' }} />}
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 14, color: '#0F172A' }}>{n.title || '\u2014'}</div>
                  <div style={{ fontSize: 13, color: '#64748B', marginTop: 4 }}>{n.body || '\u2014'}</div>
                </div>
                <div style={{ fontSize: 12, color: '#94A3B8', whiteSpace: 'nowrap' }}>
                  {n.created_at ? new Date(n.created_at).toLocaleString('ru-RU') : '\u2014'}
                </div>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <Card>
          <div style={{ textAlign: 'center', padding: 50, color: '#94A3B8', fontSize: 13 }}>Нет уведомлений</div>
        </Card>
      )}
    </div>
  );
}
